import { useCompassWebSecurityGetCentralizedOrgIdQuery } from "./get-centralized-org-id.v5.generated.js";
import { useCompassWebSecurityGetPasswordRulesQuery } from "./get-password-rules.v5.generated.js";
const useFetchPasswordRules = (options = {})=>{
    const { organizationId } = options;
    const skipSessionQuery = Boolean(organizationId);
    const { data: sessionData, loading: sessionLoading } = useCompassWebSecurityGetCentralizedOrgIdQuery({
        context: {
            clientName: 'v5'
        },
        skip: skipSessionQuery
    });
    const centralizedOrganizationId = organizationId ?? sessionData?.security.current_session?.centralized_session?.centralized_organization_id;
    const { data, loading, error } = useCompassWebSecurityGetPasswordRulesQuery({
        variables: {
            input: {
                centralized_organization_id: centralizedOrganizationId ?? ''
            }
        },
        context: {
            clientName: 'v5'
        },
        skip: !centralizedOrganizationId
    });
    const payload = data?.security_policies.password_policy;
    return {
        rules: payload?.__typename === 'GetPasswordPolicyPayload' ? payload.policy.rules : [],
        loading: sessionLoading || loading,
        error
    };
};
export { useFetchPasswordRules };
